import {useNavigate} from 'react-router-dom'
import React, {useEffect, useContext} from 'react'
import {CardMedia} from '@mui/material'
import {
    CurrencyExchangeRounded as CurrencyExchangeIcon
} from '@mui/icons-material'
import {clearText, isEmpty} from 'react-lf-tools'
import {HomeContext} from '../../../context/HomeContext.jsx'
import {getLocal, setSession} from '../../../hooks/useStorage/useStorage.jsx'
import {trackEventAnalytics, prices} from '../../../utils/utils.jsx'

import food from '../../../assets/food.jpg'

import './listProducts.scss'

const ListProducts = ({listProducts}) => {
    const navigate = useNavigate()
    const totem = getLocal('totem', false)
    const {categorys, groups, setIdGroup, setRender} = useContext(HomeContext)
    const scrollMenu = () => {
        window.onscroll = () => {
            for (let i = 0; i < categorys.length; i++) {
                try {
                    const id = clearText(categorys[i])
                    const elem = document.querySelector('#' + id)
                    let position = 0
                    const scroll = document.getElementById('scroll-categorys')
                    if (elem !== null) {
                        let bounding = elem.getBoundingClientRect()
                        if (bounding.top > -100 && bounding.top < 100) {
                            if (i === 0) {
                                setIdGroup(id)
                                scroll.scrollTo(0, 0)
                                break
                            } else if (i === 1) {
                                setIdGroup(id)
                                position = groups[0].position
                                scroll.scrollTo(position + 10, 0)
                                break
                            } else {
                                let cont = i
                                for (let t = 0; t < ++cont; t++) {
                                    setIdGroup(id)
                                    if (('#item-' + id) !== (groups[t].id)) {
                                        position += groups[t].position
                                    } else {
                                        scroll.scrollTo(position, 0)
                                        break
                                    }
                                }
                            }
                        }
                    }
                } catch (e) {
                    setRender(true)
                }
            }
        }
    }

    const handleClick = product => {
        setSession('positionPage', window.scrollY)
        navigate('/produto', {
            state: {
                product: product,
                edit: false,
                item: {},
                isCouponProduct: false
            }
        })
        trackEventAnalytics('select_item', {
            items: product
        })
        console.table(product)
    }

    const isVariousPrices = (product) => (
        (product.visibility.includes('DIGITALMENU')) &&
        (!isEmpty(product.visibleStepOne) && product.visibleStepOne) &&
        (!isEmpty(product.variations)) &&
        (!isEmpty(product.prices))
    )

    useEffect(() => scrollMenu(), [categorys, groups])

    return <div className={'list-products'}>
        {listProducts.map(item => (
            <div style={{width: '100%'}} key={item.category} id={clearText(item.category)}>
                <div className={'div-title-category'}>
                    <label className={'label-category-products'}>
                        {item.category}
                    </label>
                </div>
                <div className={'div-list-listProducts'}>
                    {item.products.map(product => {
                        return <div key={product.product} id={clearText(product.product)}
                                    className={'div-item-product'}
                                    onClick={() => handleClick(product)}>
                            <div className={'div-image'}>
                                <CardMedia
                                    className={'card-media-product'}
                                    image={(!!product.image) ? product.image : food}/>
                            </div>
                            <div className={'div-description-product-home'}>
                                <div>
                                    <label className={'product'} id={`label-${clearText(product.product)}`}>
                                        {product.product}
                                    </label>
                                    <div className={'div-description-cashback'}>
                                        <label className={'description'}>
                                            {product.description}
                                        </label>
                                        {((!totem) && (product?.cashback !== 0 && product.cashback !== undefined)) &&
                                            <div className={'div-icon-cashback'}>
                                                <label className={'label-cashback'}>
                                                    {`${product?.cashback?.toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    })} Cashback`}
                                                </label>
                                                <CurrencyExchangeIcon className={'icon-list-products'}/>
                                            </div>}
                                    </div>
                                </div>
                                <div className={'div-prices'}>
                                    {(product.oldPrice !== 0 && product.oldPrice !== undefined) &&
                                        <label className={'price-old'}>
                                            {product.oldPrice.toLocaleString('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}
                                        </label>
                                    }
                                    {(() => {
                                        if (isVariousPrices(product)) {
                                            return (<div>
                                                {prices(product.prices).map((p, i) =>
                                                    <div key={i} className={'div-prices-products'}>
                                                        <label className={'price'}>
                                                            {`${p.price.toLocaleString('pt-BR', {
                                                                style: 'currency',
                                                                currency: 'BRL'
                                                            })} ${p.description}`}
                                                        </label>
                                                    </div>)}
                                            </div>)
                                        } else {
                                            return <div className={'div-price-cashback'}>
                                                <label className={'price'}>
                                                    {(product.price !== 0) ? `${product.price.toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    })}` : 'R$ ***'}
                                                </label>
                                            </div>
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
        ))}
    </div>
}

export default ListProducts
